import { Link } from "react-router-dom";

export const COLUMNS = [
    {
        Header: "Order",
        Footer: "Order",
        accessor: "callEndTime",
        disableFilters: true,
        sticky: "left",
    },
    {
        Header: "Distributor",
        Footer: "Distributor",
        accessor: "distributor",
    },
    {
        Header: "Sales Associate",
        Footer: "Sales Associate",
        accessor: "salesassociate",
    },
    {
        Header: "Orders Details",
        Footer: "Orders Details",
        accessor: "orderdetails",
    },
    {
        Header: "Distributor Action",
        Footer: "Distributor Action",
        accessor: "order_status",
    },
];
